import { createSlice, createSelector } from '@reduxjs/toolkit';

const initialState = {
  isBranchInitialized: false,
  deepLinkPath: null,
  branchTokens: {},
};

const deepLinkSlice = createSlice({
  name: 'deepLink',
  initialState,
  reducers: {
    setIsBranchInitialized: (state, action) => {
      state.isBranchInitialized = action.payload;
    },
    setDeepLinkPath: (state, action) => {
      state.deepLinkPath = action.payload;
    },
    setBranchTokens: (state, action) => {
      state.branchTokens = action.payload;
    },
  },
});

export const { setIsBranchInitialized, setDeepLinkPath, setBranchTokens } = deepLinkSlice.actions;

export const selectIsBranchInitialized = (state) => state.deepLink.isBranchInitialized;
export const selectDeepLinkPath = (state) => state.deepLink.deepLinkPath;
export const selectBranchTokens = createSelector([(state) => state.deepLink.branchTokens], (branchTokens) => ({
  ...branchTokens,
}));
export default deepLinkSlice.reducer;
